import { jsx as _jsx } from "react/jsx-runtime";
import { AppValueTypes } from '@iotv/iotv-v3-types';
import { useMemo, useState } from 'react';
import { SimpleList } from '../../factories/Listerlizer/SimpleList';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const SimpleListWidget = (props) => {
    const [items, setItems] = useState([
        { pk: 'Device:slw', sk: 'Device:slw', id: 'slw', type: 'Device', name: 'Device', eui: '1234567812345678' },
        { pk: 'Gateway:slw1', sk: 'Gateway:slw1', id: 'slw1', type: 'Gateway', name: 'Gateway', eui: '1234567812345678' },
        { pk: 'Property:slw2', sk: 'Property:slw2', id: 'slw2', type: 'Property', name: 'Property', areas: 2 },
    ]);
    const [viewDef, setViewDef] = useState({
        name: {
            type: AppValueTypes.STRING,
            editable: false,
            label: 'Name',
            key: 'name',
        },
        type: {
            type: AppValueTypes.STRING,
            editable: false,
            label: 'Type',
            key: 'type',
        },
        eui: {
            type: AppValueTypes.STRING,
            editable: false,
            label: 'EUI',
            key: 'eui',
        },
        areas: {
            type: AppValueTypes.NUMBER,
            editable: false,
            label: '# Areas',
            key: 'areas',
        },
    });
    const component = useMemo(() => _jsx(SimpleList, { listItems: items, viewDefinition: viewDef }), [items, viewDef]);
    return {
        name: 'SimpleList',
        category: 'composite',
        component,
    };
};
